
<div class="confirm-page">
    <img class="img-valid" src="./../../../../assets/icono-pago.png" alt="">
  
    <h1>Pago Realizado con Exito</h1>
    <h2>Datos de la Factura</h2>
    <ul class="datos-pago">
        <li>ID Factura: {{idCustomFactura}}</li>
        <li>Número de Licencias: {{numeroLicencias}}</li>
        <li>Fecha de Pago: {{fechaPago}}</li>
        <li>Base Imponible: {{baseImponible}}€</li>
        <li>IVA: {{iva}}%</li>
        <li>Importe total: {{total}}€</li>
        
    </ul>
    <button class="btn-accept" [routerLink]="['/contratista/estado']" routerLinkActive="router-link-active">Aceptar</button>
</div>

